
import * as React from 'react';

import * as styles from './overlayHeadine.scss';

type Props = {
    children: React.ReactNode;
    noPaddingBottom?: boolean;
}

const OverlayHeadine:React.SFC<Props> = (props) => {
    return (
        <div className={props.noPaddingBottom ? styles.noPaddingBottomHeadline : styles.headline}>
            {props.children}
        </div>
    );  
}

export default OverlayHeadine;
